module.exports = __webpack_public_path__ + "img/TABLE.d89853fd.svg";